import { selfAxios } from "../../../../../axios/selfAxios.js";
async function postTransferQueryParam(params) {
  const res = await selfAxios.post(`/bsplatform/external/commodity/transferQueryParam`, params);
  return res.data;
}
async function getList(params) {
  const { data } = await selfAxios.get(`/commoditycenter/productClassification/list`, { params });
  return data;
}
export { getList, postTransferQueryParam };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/bsplatform/external/commodity/transferQueryParam/post.js